// Maps a lookup's or a link's {linked_table, linked_record_id} to the page + navigation
// state that opens that exact record's detail view. Single source of truth so the
// QR-lookup modal, the hub and the record pages can't drift apart on how a given
// linked_table resolves.
const LINKED_TABLE_MAP = {
  field_collection:    { path: '/collections', stateKey: 'openCollectionId' },
  plate_culture:       { path: '/plates',       stateKey: 'openPlateId' },
  mushroom_bank:        { path: '/slants',       stateKey: 'openSlantId' },
  dna:                 { path: '/dna',          stateKey: 'openDnaId' },
  dna_sequencing_runs: { path: '/dna',          stateKey: 'openRunId' },
  // The home hub's dossier links a strain too.
  strains:             { path: '/strains',      stateKey: 'openStrainId' },
};

// An intake record (external_collections) opens in the home hub, in its
// drawer (?intake=), over the isolates table: there is no External page.
// Returns { path } for navigate().
export function intakeNav(externalId) {
  return { path: `/?${new URLSearchParams({ intake: externalId })}` };
}

// Returns { path, state } to pass to react-router's navigate(), or null if this
// linked_table has no known detail-view page to deep-link into (a taxonomy
// entry, general_data, has none since the Taxonomy page went), or a link with
// no linked_table/linked_record_id at all.
export function resolveLinkedRecordNav(linkedTable, linkedRecordId) {
  if (!linkedTable || !linkedRecordId) return null;
  if (linkedTable === 'external_collections') return { ...intakeNav(linkedRecordId), state: undefined };
  const entry = LINKED_TABLE_MAP[linkedTable];
  if (!entry) return null;
  return { path: entry.path, state: { [entry.stateKey]: linkedRecordId } };
}

// Where a specimen found by its code (a /lookup answer: the navbar's code
// lookup, the scan station) opens: its own page -- or, when the answer says
// the reader sees it only `redacted` (a student whom a lab assignment alone
// admits, to whom that page's graph is 404), its dossier in the home hub,
// searched by its code so that its row is on the table's first page.
// Returns { path } for navigate().
export function specimenNav(found) {
  if (found?.redacted) {
    return { path: `/?${new URLSearchParams({ q: found.code || '', open: found.id })}` };
  }
  return { path: `/specimens/${found.id}` };
}
